// extracted by mini-css-extract-plugin
export var active = "search-bar-module--active--5e9b3";
export var dFlex = "search-bar-module--d-flex--bed73";
export var noSuggestions = "search-bar-module--no-suggestions--3c2c5";
export var search_bar = "search-bar-module--search_bar--718a9";
export var search_bar_wrapper = "search-bar-module--search_bar_wrapper--54e87";
export var search_focus = "search-bar-module--search_focus--e83a0";
export var search_input = "search-bar-module--search_input--25b1f";
export var search_more = "search-bar-module--search_more--2d717";
export var search_suggestions = "search-bar-module--search_suggestions--1351f";
export var suggestionActive = "search-bar-module--suggestion-active--97c5e";
export var suggestionImageStyle = "search-bar-module--suggestionImageStyle--3a02e";
export var suggestions = "search-bar-module--suggestions--4822b";
export var textPrimary = "search-bar-module--text-primary--90802";